import { render, staticRenderFns } from "./UploadDhlFile.vue?vue&type=template&id=1a7c47fa"
import script from "./UploadDhlFile.vue?vue&type=script&lang=js"
export * from "./UploadDhlFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports